import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useLocation, useNavigate} from "react-router-dom";
import {Button, Col, FloatingLabel, Form, Row} from "react-bootstrap";
import {useSanctum} from "react-sanctum";
import {useAuthLocalStorage} from "../../hooks/useAuthLocalStorage";
import {useStockStorage} from "../../hooks/useStockStorage";
import {toast} from "react-custom-alert";
import {useTranslation} from "react-i18next";

const OTPCode = ({...props}: ModalProps)  => {
    const{removeSessionStockAll} = useStockStorage();

    const { t } = useTranslation();
    let navigate = useNavigate();

    const [code, setCode] = useState("");
    const [recoveryCode, setRecoveryCode] = useState("");

    const {twoFactorChallenge} = useSanctum();

    const {setAppUniqueToken} = useAppUniqueToken();
    const {setAuthLocalStorageKey} = useAuthLocalStorage();

    const handleTwoFactorChallenge = (recovery = false) => {
        //console.log('code: ' + code);
        if(code && code !== '')
        {
            /*
            ///user/confirmed-two-factor-authentication
            axios.post('two-factor-challenge', [code], {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {
                //alert('user/two-factor-authentication:');
                //alert(response);

                console.log('axios /user/confirmed-two-factor-authentication');
                console.log(response);

            }).catch(error => {
                console.log('user/user/confirmed-two-factor-authentication');
                console.log(error);
            });
   */
            twoFactorChallenge(recovery ? recoveryCode : code, recovery)
                .then((response) => {

                    //console.log("handleTwoFactorChallenge")
                    //console.log(response);

                    setAuthLocalStorageKey(true);
                    setAppUniqueToken(null);

                    //props.onHide?.();

                    removeSessionStockAll();

                    navigate('/');
                })
                .catch(() => toast.error(t('messages.otpLoginFail')));
        }
    };

    /*
    *
    *  <hr />
                    <Row>
                        <Form.Group as={Col} controlId="validationRecovery-token">
                            <FloatingLabel controlId="floatingInput" label="Recovery-token" className="mb-3 text-black">
                                <Form.Control type="text"
                                              size="sm"
                                              placeholder="Recovery-token"
                                              value={recoveryCode}
                                              onInput={(e) => setRecoveryCode(e.currentTarget.value)}
                                />
                            </FloatingLabel>
                            <Button className="btn_1 green" onClick={() => handleTwoFactorChallenge(true)}>
                                Inizia qui
                            </Button>
                        </Form.Group>
                    </Row>
    * */

    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <h1><b>{t('captions.otpAuthentication')}</b></h1>
            </Modal.Header>
            <Modal.Body className={'p-5'}>
                {t('labels.otpAuthentication')}
                <Form.Group>
                    <FloatingLabel controlId="floatingInput" label={t('labels.otpCode')} className="mb-3 text-black">
                        <Form.Control type="text"
                                      size="sm"
                                      placeholder={t('labels.otpAuthentication').toString()}
                                      value={code}
                                      onInput={(e) => setCode(e.currentTarget.value)}
                        />
                    </FloatingLabel>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn_1 green" onClick={() => handleTwoFactorChallenge()}>
                    {t('captions.logIn')}
                </Button>
                <Button className="btn_1 yellow" onClick={props.onHide}>
                    {t('captions.cancel')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
/*
 <Form.Group controlId="formFile" className="mb-3 mt-3">
                    <Form.Label>Hai la ricevuta di pagamento?</Form.Label>
                    <Form.Control type="file" onChange={(e) => setFilePath(e.target.value)}/>
                </Form.Group>
* */
export default OTPCode;
